<template>
  <section>
    <div class="md:flex md:items-center">
      <h1 v-if="slots.pageTitle" class="heading-1 mb-16 md:flex-1">
        <slot name="pageTitle" />
      </h1>

      <div v-if="slots.pageActions">
        <slot name="pageActions" />
      </div>
    </div>

    <div v-if="slots.pageContent">
      <slot name="pageContent" />
    </div>
  </section>
</template>

<script lang="ts" setup>
import { useHead } from '#imports'
import type { VNode } from 'vue'

const props = defineProps<{
  title?: string
  meta?: Record<string, string>[]
}>()

const slots = defineSlots<{
  pageTitle?(): VNode
  pageContent?(): VNode
  pageActions?(): VNode
}>()

if (props.title) {
  useHead({
    title: props.title,
    meta: props.meta || [],
  })
}
</script>
